import { render } from "./AboutPartners.vue?vue&type=template&id=33333463"
import script from "./AboutPartners.vue?vue&type=script&lang=js"
export * from "./AboutPartners.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__